var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 10.082C2.75 6.64478 2.75 4.92615 3.62533 3.72135C3.90803 3.33225 4.25022 2.99007 4.63931 2.70737C5.84412 1.83203 7.56275 1.83203 11 1.83203C14.4372 1.83203 16.1559 1.83203 17.3607 2.70737C17.7498 2.99007 18.092 3.33225 18.3747 3.72135C19.25 4.92615 19.25 6.64478 19.25 10.082V11.9154C19.25 15.3526 19.25 17.0712 18.3747 18.276C18.092 18.6651 17.7498 19.0073 17.3607 19.29C16.1559 20.1654 14.4372 20.1654 11 20.1654C7.56275 20.1654 5.84412 20.1654 4.63931 19.29C4.25022 19.0073 3.90803 18.6651 3.62533 18.276C2.75 17.0712 2.75 15.3526 2.75 11.9154V10.082Z",
    stroke: "#15CF5F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 11.918L12.9643 10.0846M12.9643 10.0846L11.543 6.76846C11.4522 6.55631 11.2378 6.41797 11 6.41797C10.7622 6.41797 10.5478 6.55631 10.457 6.76846L9.03571 10.0846M12.9643 10.0846H9.03571M8.25 11.918L9.03571 10.0846",
    stroke: "#15CF5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 15.582H14.6673",
    stroke: "#15CF5F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.59ffede5ffb84940443d8017ff6932aa.svg";
export { ForwardRef as ReactComponent };